import styled from 'styled-components';

import {string} from 'yup';

import {colors, font, border} from 'theme';

export const Root = styled.div`
    display: flex;
    flex-direction: column;
    gap: 30px;
`;

export const Container = styled.div`
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: stretch;
    gap: 10px;
`;

export const MarkedSectionControl = styled.div`
    width: 100%;
    height: auto;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
`;

export const SearchWrapper = styled.div`
    width: 330px;
    height: auto;
`;

export const AddInvoiceLineForm = styled.form`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;
    overflow: auto hidden;
`;

export const ColumnNames = styled.input<{className?: string}>`
    width: 90%;
    max-width: 90%;
    height: 42px;
    border: 1px solid ${colors.textMuted};
    box-sizing: border-box;
    padding: 0 16px;
    border-radius: ${border.radius};
`;

export const RequiredTag = styled.div`
    margin-left: 4px;
    font-family: ${font.family.primary};
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0;
    color: ${colors.warnings};
    content: '*';
`;

export const Headline = styled.div`
    display: grid;
    grid-template-columns: 1fr 320px;
    grid-template-rows: repeat(2, 1fr);
    padding: 0;
    margin: 0;

    & > h3 {
        font-family: ${font.family.primary};
        font-weight: 700;
        font-size: 20px;
        line-height: 24px;
        letter-spacing: 2%;
        text-transform: uppercase;
        margin: 0;
    }
`;

export const Highlighted = styled.span`
    color: ${colors.brandPrimary};
`;

export const SectionDescription = styled.span`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    font-family: ${font.family.primary};
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    letter-spacing: 0;
    color: ${colors.textSecondary};

    & > div {
        display: flex;
        flex-direction: column;
    }

    & > button {
        width: fit-content;
    }
`;

export const ButtonSubmit = styled.button<{bgDark?: boolean}>`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    outline: none;
    border: 0;
    border-radius: ${border.radius};
    width: 178px;
    height: 44px;
    color: ${(p) => (p.bgDark ? colors.white : colors.brandPrimary)};
    cursor: pointer;
    background-color: ${(p) => (p.bgDark ? colors.brandDark : colors.brandLight)};
    &:disabled {
        color: #8a8a8a;
        background-color: #efefef;
    }
`;

export const RoundNumber = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 26px;
    height: 26px;
    border-radius: 100%;
    background-color: #f2f2ff;
    color: ${colors.brandPrimary};
`;

export const HorizontalLine = styled.hr`
    width: 100%;
    height: 1px;
    padding: 0;
    margin: 0;
    outline: 0;
    border: none;
    background-color: #e8e8e8;
`;

export const HeaderGroupWrapper = styled.div<{flexDirection?: string}>`
    width: 100%;
    display: flex;
    flex-direction: ${(p) => p.flexDirection ?? ''};
    justify-content: space-between;
    gap: 4px;
`;

export const HeaderGroupItem = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
`;

export const TextWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    gap: 8px;
`;
export const TextWrapperRow = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 100%;
    gap: 8px;
`;

export const TextWrapperItem = styled.div<{withSeparator?: boolean}>`
    display: inline-flex;
    align-items: center;
    justify-content: stretch;
    gap: 8px;

    font-family: ${font.family.primary};
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: ${colors.darkGrey};
    ${(p) =>
        p.withSeparator &&
        `
            &:before {
                content: '';
                width: 1px;
                height: 18px;
                background: ${colors.textMuted};
            }
        `}
`;

export const InputWrapper = styled.div`
    display: flex;
    width: 100%;
    height: auto;
    gap: 4px;
`;

export const RowText = styled.div<{padding?: string}>`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    color: ${colors.black};
    padding: ${(p) => p.padding ?? '0 16px'};
    border-radius: ${border.radius};
    font-family: ${font.family.primary};
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0;
`;
export const RowTextEllipsis = styled.div`
    width: 100%;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    white-space: normal;
    word-break: break-word;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 30ch;
`;

export const Text = styled.input<{
    backgroundTransparent?: boolean;
    hasError?: boolean;
    shortHeight?: boolean;
}>`
    box-sizing: border-box;
    width: 100%;
    height: auto;
    min-height: ${(p) => (p.shortHeight ? '33px' : '36px')};
    color: ${colors.black};
    font-family: ${font.family.primary};
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0;
    background-color: ${(p) => (p.backgroundTransparent ? 'transparent' : '#f7f7f7')};

    padding: 0 16px;
    border: ${(p) => (p.hasError ? '1px solid tomato' : 'transparent')};
    border-radius: ${border.radius};
    outline: 0;
`;
export const ChargesControl = styled.div<{justify?: string}>`
    width: 100%;
    justify-content: ${(p) => p.justify ?? 'flex-start'};
    display: inline-flex;
    align-items: center;
    gap: 8px;
`;
export const ControlContainer = styled.div`
    margin-left: auto;
    display: flex;
    gap: 8px;
`;
export const ButtonGroup = styled.div`
    display: flex;
    gap: 8px;

    grid-row: 1 / -1;
    grid-column: 2;
`;
